import type { AxiosInstance } from 'axios'

import { identifyAxios } from './identification/identifyAxios'
import { toDomainHttpClient } from './toDomainHttpClient'

// identifyAxios 는 skipErrorToast 를 더한 좁은 인스턴스 타입이라 axios 인스턴스로 넓혀 넘긴다.
// 어댑터가 preventErrorToast: true 를 skipErrorToast 로 옮긴다.
export const domainIdentifyHttpClient = toDomainHttpClient(
  identifyAxios as unknown as AxiosInstance,
  { forwardMeta: false },
)
